import { createStore } from 'vuex';
import authorization from './authorization';
import documents from './documents';
import global from './global';

import { subscribePendingStoreActions } from './plugins';

export default createStore({
  modules: {
    authorization,
    documents,
    global,
  },
  plugins: [subscribePendingStoreActions],
});
